import createIcon from '../../createIcon';

/**
 * @component @name AirlineSeatIndividualSuite
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxNEM4LjY2IDE0IDEwIDEyLjY2IDEwIDExQzEwIDkuMzQgOC42NiA4IDcgOEM1LjM0IDggNCA5LjM0IDQgMTFDNCAxMi42NiA1LjM0IDE0IDcgMTRaTTcgMTBDNy41NSAxMCA4IDEwLjQ1IDggMTFDOCAxMS41NSA3LjU1IDEyIDcgMTJDNi40NSAxMiA2IDExLjU1IDYgMTFDNiAxMC40NSA2LjQ1IDEwIDcgMTBaTTE5IDdIMTFWMTVIM1Y3SDFWMTdIMjNWMTFDMjMgOC43OSAyMS4yMSA3IDE5IDdaTTIxIDE1SDEzVjlIMTlDMjAuMSA5IDIxIDkuOSAyMSAxMVYxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirlineSeatIndividualSuite = createIcon('AirlineSeatIndividualSuite', [
  [
    'path',
    {
      d: 'M7 14C8.66 14 10 12.66 10 11C10 9.34 8.66 8 7 8C5.34 8 4 9.34 4 11C4 12.66 5.34 14 7 14ZM7 10C7.55 10 8 10.45 8 11C8 11.55 7.55 12 7 12C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10ZM19 7H11V15H3V7H1V17H23V11C23 8.79 21.21 7 19 7ZM21 15H13V9H19C20.1 9 21 9.9 21 11V15Z',
      key: '1s1x81',
    },
  ],
]);

export default AirlineSeatIndividualSuite;
